import { Directive, Input } from '@angular/core';

import { WdOriginType } from '../../models/telemetry-constants.model';
import { MruFileItem } from '../../mru/mru-file-item.model';
import { WacContentService } from '../../services/wac-content.service';
import { CapabilitiesService } from '../../shared-context/capabilities.service';
import { HoverActionDirective } from './hover-action.directive';

@Directive({
    selector: '[ohpDocumentPreload]'
})
export class DocumentPreloadDirective extends HoverActionDirective {

    @Input('ohpDocumentPreload') private readonly itemInfo: { item: MruFileItem, wdOriginType: WdOriginType };

    constructor(
        private readonly capabilitiesService: CapabilitiesService,
        private readonly wacContentService: WacContentService
    ) {
        super(() => this.wacContentService.loadMruItem(this.itemInfo.item, this.itemInfo.wdOriginType, true));
    }

    protected enabled() {
        return this.capabilitiesService.wacHostEnabledForFileType(this.itemInfo.item.fileType) && this.capabilitiesService.capabilities.wacHostHoverPreloadEnabled;
    }
}
